
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tickets",
      function () {
        return require("private-next-pages/tickets/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tickets"])
      });
    }
  